export default function() {
    // FB.getLoginStatus(function(response) {
    //     if (response.status === 'connected') {
    //         console.log('Logged in.');
    //     }
    //     else {
    //         FB.login();
    //     }
    // });

    const targetYear = 2017;

    // get min & max
    const getMinMaxLikes = (arr) => {
        let min = arr[0];
        let max = arr[0];
        for (let i = 1, len = arr.length; i < len; i++) {
            let v = arr[i];
            min = v.likes < min.likes ? v : min;
            max = v.likes > max.likes ? v : max;
        }
        return {min: min, max: max};
    }



    const fbUser = {
        id: 0,
        firstName: '',
        lastName: '',
        photo: '',
        link: ''
    };
    let fbUserPosts = [];
    let fbPostsWithLikes = [];

    // get reactions
    const fbGetReactions = posts => {
        posts.forEach(post => {
            FB.api(`/${post.id}/reactions?summary=true`, res => {
                if (res && !res.error) {

                    fbPostsWithLikes.push({id: post.id, likes: res.summary.total_count});

                    if (fbPostsWithLikes.length === fbUserPosts.length) {
                        const maxId = getMinMaxLikes(fbPostsWithLikes).max.id;
                        const maxIdDash = maxId.indexOf('_');

                        document.querySelector('.socialstat__facebook-post').innerHTML = `<div class="fb-post" data-href="https://www.facebook.com/${maxId.substring(0, maxIdDash)}/posts/${maxId.substring(maxIdDash + 1)}/" data-show-text="true"></div>`;

                        FB.XFBML.parse(document.querySelector('.socialstat__facebook-post'));
                    }
                }
            });
        });
    };

    // get posts and add to array
    const fbGetPosts = apiRequest => {
        FB.api(apiRequest, res => {
            if (res && !res.error) {
                const lastElemDate = res.data[res.data.length - 1].created_time;

                if (new Date(lastElemDate).getFullYear() === targetYear) {

                    fbUserPosts = fbUserPosts.concat(res.data);

                    fbGetPosts(res.paging.next);

                } else {

                    const targetYearPosts = res.data.filter(item => new Date(item.created_time).getFullYear() === targetYear);

                    fbUserPosts = fbUserPosts.concat(targetYearPosts);

                    if (fbUserPosts.length > 0) {
                        fbGetReactions(fbUserPosts);
                    } else {
                        document.querySelector('.socialstat__facebook-post').innerHTML = `Нет постов за ${targetYear} год`;
                    }

                }
                console.log(fbUserPosts)
            }
        });
    };

    const fbPrintUser = user => {
        document.querySelector('.socialstat__facebook-user').innerHTML = `
            <figure class="fbuser">
                <a href="${user.link}" target="_blank"><img src="${user.photo}" alt=""></a>
                <figcaption><a href="${user.link}" target="_blank">${user.firstName} ${user.lastName}</a></figcaption>
            </figure>
        `;
    };

    const fbGetUser = userId => {
        FB.api(`/${userId}?fields=id,first_name,last_name,link`, res => {
            if (res && !res.error) {
                fbUser.firstName = res.first_name;
                fbUser.lastName = res.last_name;
                fbUser.link = res.link;

                FB.api(`/${userId}/picture`, resPhoto => {
                    if (resPhoto && !resPhoto.error) {
                        fbUser.photo = resPhoto.data.url;
                        fbPrintUser(fbUser);
                    }
                });
            }
        });
    };

    document.querySelector('.socialstat__facebook').addEventListener('click', () => {
        document.querySelector('.socialstat__facebook-post').innerHTML = `<img src="https://icongr.am/feather/loader.svg?size=32" alt="">`;
        FB.login(res => {
            if (res.status === 'connected' && res.authResponse.grantedScopes === 'user_posts,public_profile') {
                const userId = 'me';
                fbGetUser(userId);
                fbGetPosts(`/${userId}/posts?limit=100`);
            } else {
                document.querySelector('.socialstat__facebook-post').innerHTML = `Произошла ошибка авторизации. Попробуйте ещё раз`;
            }
        }, {
            scope: 'user_posts',
            return_scopes: true
        });
    });



    VK.init({apiId: 6345908});

    const vkUser = {
        id: 0,
        firstName: '',
        lastName: '',
        photo: 'https://vk.com/images/camera_b.gif',
        link: ''
    };
    const vkPost = {
        id: 0,
        attachment: {},
        text: '',
        likes: '',
        link: ''
    };
    let vkUserPosts = [];
    let vkPostsWithLikes = [];
    let vkOffsetCount = 0;

    const vkPrintPost = post => {
        const isAttachment = post.attachment ? true : false;
        const isPhoto = post.attachment.photo ? true : false;
        const isVideo = post.attachment.video ? true : false;
        const isLink = post.attachment.link ? true : false;

        let contentPhoto = '';
        if (isPhoto) {
            contentPhoto = post.attachment.photo.src_xbig ? post.attachment.photo.src_xbig : post.attachment.photo.src_big ? post.attachment.photo.src_big : post.attachment.photo.src;
        }

        const contentVideo = {
            link: '',
            src: '',
            title: '',
            desc: ''
        };
        if (isVideo) {
            contentVideo.url = `https://vk.com/video${post.attachment.video.owner_id}_${post.attachment.video.vid}`;
            contentVideo.src = post.attachment.video.image_big ? post.attachment.video.image_big : post.attachment.video.image ? post.attachment.video.image : '';
            contentVideo.title = post.attachment.video.title;
            contentVideo.desc = post.attachment.video.description ? post.attachment.video.description : '';
        }

        const contentLink = {
            url: '',
            src: '',
            title: '',
            desc: ''
        };
        if (isLink) {
            contentLink.url = post.attachment.link.url;
            contentLink.src = post.attachment.link.image_big ? post.attachment.link.image_big : post.attachment.link.image_src ? post.attachment.link.image_src : '';
            contentLink.title = post.attachment.link.title;
            contentLink.desc = post.attachment.link.description ? post.attachment.link.description : '';
        }

        document.querySelector('.socialstat__vk-post').innerHTML = `
            <article class="vkpost">
                ${post.text ? `<div class="vkpost__text">${post.text}</div>` : ``}
                ${isAttachment ? `
                    <div class="vkpost__attachment">
                        ${isPhoto ? `
                            <img src="${contentPhoto}" alt="" class="vkpost__photo">
                        ` : ''}
                        ${isVideo ? `
                            <a href="${contentVideo.url}" target="_blank">
                                ${contentVideo.src !== '' ? `<img src="${contentVideo.src}" alt=""><br>` : ''}
                                <img src="https://icongr.am/material/play.svg?size=16" alt=""><strong>${contentVideo.title}</strong>
                                ${contentVideo.desc !== '' ? `<br><small>${contentVideo.desc}</small>` : ''}
                            </a>
                        ` : ''}
                        ${isLink ? `
                            <a href="${contentLink.url}" target="_blank">
                                ${contentLink.src !== '' ? `<img src="${contentLink.src}" alt=""><br>` : ''}
                                <strong>${contentLink.title}</strong>
                                ${contentLink.desc !== '' ? `<br><small>${contentLink.desc}</small>` : ''}
                            </a>
                        ` : ''}
                    </div>
                ` : ``}
                ${post.likes !== '' ? `<div><img src="https://icongr.am/material/heart.svg?size=16&color=4a76a8" alt=""> ${post.likes}</div>` : ''}
                ${post.link !== '' ? `<footer class="vkpost__footer"><a href="${post.link}" target="_blank">Ссылка</a></footer>` : ''}
            </article>
        `;
    };

    const vkGetLikes = posts => {
        posts.forEach(post => {
            vkPostsWithLikes.push({
                postId: post.id,
                userId: post.to_id,
                attachment: post.attachment,
                text: post.text,
                likes: post.likes.count
            });
            if (vkPostsWithLikes.length === vkUserPosts.length) {
                const maxLikesPost = getMinMaxLikes(vkPostsWithLikes).max;

                vkPost.id = maxLikesPost.postId;
                vkPost.attachment = maxLikesPost.attachment;
                vkPost.text = maxLikesPost.text;
                vkPost.likes = maxLikesPost.likes;
                vkPost.link = `https://vk.com/wall${maxLikesPost.userId}_${maxLikesPost.postId}`;

                vkPrintPost(vkPost);
            }
        });
    };

    const vkFilterPosts = posts => {
        return posts.filter(post => post.post_type === 'post' && !post.copy_history);
    };

    const vkGetPosts = (userId, offset) => {
        VK.api('wall.get', {owner_id: userId, offset: offset, filter: 'owner', count: 100}, res => {
            if (res.response) {
                const lastElemDate = res.response[res.response.length - 1].date;

                if (new Date(lastElemDate * 1000).getFullYear() === targetYear) {

                    vkOffsetCount++;

                    vkUserPosts = vkUserPosts.concat(vkFilterPosts(res.response));

                    if (vkOffsetCount === 8) {
                        vkGetLikes(vkUserPosts);
                    } else {
                        vkGetPosts(userId, 100 * vkOffsetCount);
                    }

                } else {

                    const targetYearPosts = res.response.filter(item => new Date(item.date * 1000).getFullYear() === targetYear);

                    vkUserPosts = vkUserPosts.concat(vkFilterPosts(targetYearPosts));

                    if (vkUserPosts.length > 0) {
                        vkGetLikes(vkUserPosts);
                    } else {
                        vkPost.text = `Нет постов за ${targetYear} год`;
                        vkPrintPost(vkPost);
                    }

                }

            }
        });
    };

    const vkPrintUser = user => {
        document.querySelector('.socialstat__vk-user').innerHTML = `
            <figure class="vkuser">
                <a href="${user.link}" target="_blank"><img src="${user.photo}" alt=""></a>
                <figcaption><a href="${user.link}" target="_blank">${user.firstName} ${user.lastName}</a></figcaption>
            </figure>
        `;
    };

    const vkGetPhoto = (userId) => {
        VK.api('users.get', {user_ids: userId, fields: 'photo_max,domain'}, res => {
            if (res.response) {
                vkUser.photo = res.response[0].photo_max;
                vkUser.link = `https://vk.com/${res.response[0].domain}`;

                vkPrintUser(vkUser);
            }
        });
    };

    document.querySelector('.socialstat__vk').addEventListener('click', () => {
        document.querySelector('.socialstat__vk-post').innerHTML = `<img src="https://icongr.am/feather/loader.svg?size=32" alt="">`;
        VK.Auth.login(res => {

            if (res.session) {

                vkUser.id = res.session.user.id;
                vkUser.firstName = res.session.user.first_name;
                vkUser.lastName = res.session.user.last_name;

                vkGetPhoto(vkUser.id);

                vkGetPosts(vkUser.id, 0);

            } else {
                document.querySelector('.socialstat__vk-post').innerHTML = `Произошла ошибка авторизации. Попробуйте ещё раз`;
            }

        }, 8192);
    });
}


// WEBPACK FOOTER //
// ./js/socialstat.js